export const CUSTOMERS_AUTH_REQUEST = 'CUSTOMERS_AUTH_REQUEST';
export const CUSTOMERS_AUTH_SUCCESS = 'CUSTOMERS_AUTH_SUCCESS';
export const CUSTOMERS_AUTH_ERROR = 'CUSTOMERS_AUTH_ERROR';
export const CUSTOMERS_AUTH_LOGOUT = 'CUSTOMERS_AUTH_LOGOUT';
export const CUSTOMERS_AUTH_401 = 'CUSTOMERS_AUTH_401';